import React from 'react'

export default function SubmittedData(){
    return <p>Submitted Data</p>
}